import * as React from 'react';

import { useVoiceboxPanelData } from 'bones/components/molecules/Voicebox/context/VoiceboxPanelData';
import { useVoiceboxSettings } from 'bones/components/molecules/Voicebox/context/VoiceboxSettings';
import { DEFAULT_MODEL_NAME } from 'bones/constants/model';
import { Link } from 'bones/design-system/components/Link';
import { QueryBuilderModel } from 'bones/utils/queryBuilder/model';

export interface VoiceboxPanelLinkProps {
  children?: React.ReactNode;
  iri: string;
  keepHistory?: boolean;
  messageId: string;
  tagName?: keyof JSX.IntrinsicElements;
  testId?: string;
}

export const VoiceboxPanelLink: React.VFC<VoiceboxPanelLinkProps> = ({
  children,
  iri,
  keepHistory = true,
  messageId,
  tagName = 'div',
  testId,
}) => {
  const { addPanelHistory, setPanelHistory, getLabelOrLocalName } =
    useVoiceboxPanelData();
  const { modelsByDatabaseId, settings } = useVoiceboxSettings();

  const body = children || getLabelOrLocalName(iri);

  const model = modelsByDatabaseId[settings.databaseId]?.[
    settings.model || DEFAULT_MODEL_NAME
  ] as QueryBuilderModel | undefined;

  if (model?.propertiesByIri[iri]) {
    return React.createElement(tagName, undefined, body);
  }

  return (
    <Link
      onClick={(evt) => {
        evt.preventDefault();
        if (keepHistory) {
          addPanelHistory({ iri, messageId });
        } else {
          setPanelHistory((prev) => {
            const next = prev?.slice(0);
            const last = next?.pop();

            return [
              last && last.messageId === messageId
                ? { ...last }
                : { messageId },
              { iri, messageId },
            ];
          });
        }
      }}
      role="button"
      size="md"
      tabIndex={0}
      testId={testId}
    >
      {body}
    </Link>
  );
};
